// Landing page logic for entering code or creating new document

const codeInput = document.getElementById('code-input');
const joinBtn = document.getElementById('join-btn');
const createBtn = document.getElementById('create-btn');
const errorMsg = document.getElementById('error-msg');

// Format: NNN-MMM (e.g., "123-456")
const CODE_REGEX = /^\d{3}-\d{3}$/;

// Auto-format input: add dash after 3 digits
codeInput.addEventListener('input', (e) => {
    let value = e.target.value.replace(/[^\d]/g, ''); // Remove non-digits

    // Limit to 6 digits
    if (value.length > 6) {
        value = value.slice(0, 6);
    }

    // Add dash after first 3 digits
    if (value.length > 3) {
        value = value.slice(0, 3) + '-' + value.slice(3);
    }

    e.target.value = value;

    // Validate and enable/disable join button
    const isValid = CODE_REGEX.test(value);
    joinBtn.disabled = !isValid;

    // Hide error when user starts typing
    if (errorMsg.classList.contains('show')) {
        errorMsg.classList.remove('show');
    }
});

// Handle Enter key in input
codeInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter' && !joinBtn.disabled) {
        handleJoin();
    }
});

// Handle join button click
joinBtn.addEventListener('click', handleJoin);

function handleJoin() {
    const code = codeInput.value.trim();

    if (!CODE_REGEX.test(code)) {
        errorMsg.classList.add('show');
        return;
    }

    // Navigate to document with this code
    window.location.href = `/${code}`;
}

// Handle create new document
createBtn.addEventListener('click', async () => {
    try {
        createBtn.disabled = true;
        createBtn.textContent = 'Creating...';

        // Call API to create new document
        const response = await fetch('/api/new', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to create document');
        }

        const data = await response.json();

        // Redirect to new document
        window.location.href = `/${data.code}`;
    } catch (error) {
        console.error('Error creating document:', error);
        createBtn.disabled = false;
        createBtn.textContent = 'Create New Document';
        errorMsg.textContent = 'Failed to create document. Please try again.';
        errorMsg.classList.add('show');
    }
});

// Focus input on load
codeInput.focus();
